// store/helperTips.ts
import { create } from "zustand";

type HelperTipState = {
  dismissedKeys: Record<string, boolean>;
  dismiss: (key: string) => void;
  isDismissed: (key: string) => boolean;
};

export const useHelperTipStore = create<HelperTipState>((set, get) => ({
  dismissedKeys: {},

  dismiss: (key) => {
    localStorage.setItem(key, "true");
    set((state) => ({
      dismissedKeys: {
        ...state.dismissedKeys,
        [key]: true,
      },
    }));
  },

  isDismissed: (key) => {
    return (
      get().dismissedKeys[key] ||
      (typeof localStorage !== "undefined" &&
        localStorage.getItem(key) === "true")
    );
  },
}));
